import { useEffect } from "react";
import { tg } from "./tg";

type Opts = {
  text: string;
  onClick: () => void;
  visible?: boolean;
  active?: boolean;
  loading?: boolean;
};

export function useMainButton({ text, onClick, visible = true, active = true, loading = false }: Opts) {
  useEffect(() => {
    const wa = tg();
    if (!wa) return;
    const btn = wa.MainButton;
    // Фирменный изумруд (см. «Дизайн фронта» в CLAUDE.md) — иначе кнопка берёт синий из
    // темы мессенджера. Нативную кнопку красит только Telegram API, не наш CSS.
    btn.setParams({ color: "#16D194", text_color: "#0C1013" });
    // Telegram кидает WebAppBottomButtonParamInvalid при пустом тексте — поэтому
    // setText/show вызываем только когда текст непустой; иначе просто прячем кнопку.
    const shouldShow = visible && !!text;
    if (shouldShow) {
      btn.setText(text);
      btn.show();
      if (active && !loading) btn.enable(); else btn.disable();
      if (loading) btn.showProgress(true); else btn.hideProgress();
    } else {
      btn.hideProgress();
      btn.hide();
    }
    btn.onClick(onClick);
    return () => {
      btn.offClick(onClick);
    };
  }, [text, visible, active, loading, onClick]);

  useEffect(() => {
    return () => {
      const wa = tg();
      wa?.MainButton.hide();
      wa?.MainButton.hideProgress();
    };
  }, []);
}

export function useBackButton(onClick?: () => void) {
  useEffect(() => {
    const wa = tg();
    if (!wa) return;
    const b = wa.BackButton;
    if (onClick) {
      b.show();
      b.onClick(onClick);
    } else {
      b.hide();
    }
    return () => {
      if (onClick) b.offClick(onClick);
      b.hide();
    };
  }, [onClick]);
}
